<template>
  <div id="toucan-dropdown-window">
    <div class="saved-filters">
      <!-- Toggle between saved filters -->
      <div v-if="json && json.filters && json.filters.length">
        <p class="saved-header">
          Saved Filters
        </p>
        <div v-for="(filter, idx) in json.filters" :key="idx" class="filter-item">
          <SavedFilter :keywords="filter.keywords" :idx="idx" :is-checked="checkedIndex === idx " @updateToucan="updateToucan" />
        </div>
      </div>
    </div>
    <!-- Filter input bar -->
    <div class="filter-bar">
      <div class="filter-list">
        <p class="label">
          Filter by:
        </p>

        <!-- Filter keywords tags -->
        <ul class="selected-words">
          <li v-for="(word,index) in currentFilter.keywords" :key="index" class="all-tags">
            <span class="filtered-tag">{{ word }}<i title="Remove Tag" tooltip="Delete Tag" class="material-icons small-icon" style="cursor: pointer; margin-left:5px;" @click.stop="deleteWord(word, index)">clear</i></span>
          </li>
        </ul>
      </div>
      <Button size="small" :loading="savingNewFilter" :disabled="currentFilter.keywords.length === 0" class="btn btn-primary filter-button" mode="link" @click="saveFilter">
        Save Filter
      </Button>
    </div>
    <div>
      <div class="toucan-filter-bar">
        <input
          ref="input"
          v-model="currentSearch"
          class="filter-input"
          placeholder="Search keywords or phrases"
          @keyup.enter="addNewWord(false)"
        >
      </div>
    </div>

    <!-- Top terms -->
    <div style="margin:5px 0 10px 0; font-weight:bold; position: relative;">
      <span class="suggestions">Suggested keywords</span>
    </div>
    <div v-if="topTerms.length > 0" class="flex-kk">
      <div v-for="(term,index) in topTerms" :key="index" class="flex-aa" @click="toggleTagWord(term.word)">
        <Checkbox
          class="checkbox"
          :value="!currentFilter.isRadioButton && currentFilter.keywords.includes(term.word)"
          @click="toggleTagWord(term.word)"
        />
        <span class="top-term" @click.stop="addNewWord(true,term.word)"> {{ term.word }} ({{ term.count }})</span>
      </div>
    </div>
    <div v-if="topTerms.length === 0" style="margin-bottom: 30px;">
      <span>None found</span>
    </div>

    <!-- Advanced options button -->
    <div>
      <a class="advanced-filtering-label" style="position: relative; cursor:pointer;" @click.stop="showAdvancedOptions = !showAdvancedOptions">
        <Icon v-if="!showAdvancedOptions" name="keyboard_arrow_right" style="font-size: 15px; position:relative; margin-right: 2px;" />
        <Icon v-if="showAdvancedOptions" name="keyboard_arrow_down" style="font-size: 15px; position:relative; margin-right: 2px;" />
        Advanced filtering options
      </a>
    </div>

    <!-- Advanced options (TODO: FIX THIS MESS) -->
    <div v-if="showAdvancedOptions" style="margin-top:20px;">
      <input id="AND" :checked="currentFilter.logicOperator === 'AND'" type="radio" value="AND" @click="updateFilterLogic('AND')">
      <label class="advanced-filter-options" for="AND" @click="updateFilterLogic('AND')">
        Show results that <b>include all</b> the keywords
      </label>
      <br>
      <input id="OR" :checked="currentFilter.logicOperator === 'OR'" type="radio" value="OR" @click="updateFilterLogic('OR')">
      <label class="advanced-filter-options" for="OR" @click="updateFilterLogic('OR')">
        Show results that <b>include at least one</b> of the keywords
      </label>
      <br>
      <input id="NOT" :checked="currentFilter.logicOperator === 'NOT'" type="radio" value="NOT" @click="updateFilterLogic('NOT')">
      <label class="advanced-filter-options" for="NOT" @click="updateFilterLogic('NOT')">
        Show results that <b>do not include</b> the keywords
      </label>
    </div>

    <transition name="slide-down">
      <!-- Filter footer -->
      <div v-show="showFilterFooter" id="filter-footer">
        <!-- Total responses message -->
        <div class="filter-response-count">
          <span v-if="currentFilter.totalResponses == 0">No responses match this filter</span>
          <span v-if="currentFilter.totalResponses > 0"> <b>{{ currentFilter.totalResponses }}</b> out of <b>{{ originalTotalResponses }}</b> responses</span>
        </div>
        <div class="filter-save-cancel">
          <Button class="btn" size="small" mode="secondary" @click.stop="clearAll">
            CLEAR APPLIED FILTERS
          </Button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'
import { Icon, Button, Checkbox } from '@alpha/ink'
import SavedFilter from '@/components/TestDetails/SavedFilter.vue'

export default {
  components: {
    Icon,
    Button,
    Checkbox,
    SavedFilter
  },
  props: [
    'currentFilter',
    'topTerms',
    'savingNewFilter',
    'originalTotalResponses',
    'json',
    'checkedIndex'
  ],
  data: function () {
    return {
      currentSearch: '',
      showAdvancedOptions: false,
      checked: false,
      checkedTerms: [],
      savedFilterChecked: null
    }
  },
  computed: {
    buttonCursor: function () {
      return this.currentFilter.keywords.length === 0 ? 'not-allowed' : 'pointer'
    },
    showFilterFooter: function () {
      return this.currentFilter.keywords.length > 0 || (this.json && this.json.filters && this.json.filters.length > 0)
    }
  },
  methods: {
    updateToucan (data) {
      this.$emit('updateToucan', data)
    },
    addNewWord: function (isTopWord, word) {
      var that = this
      var newWord = isTopWord ? word : this.currentSearch
      if (newWord.length > 0 && _.findIndex(that.currentFilter.keywords, function (w) { return w === newWord }) === -1) {
        this.$emit('updateToucan', {
          type: 'addKeyword',
          data: newWord
        })
        that.currentSearch = ''
      }
    },
    deleteWord: function (word, index) {
      this.$emit('updateToucan', {
        type: 'deleteKeyword',
        data: index
      })
    },
    toggleTagWord: function (word, index) {
      if (this.currentFilter.keywords.includes(word)) {
        const index = this.currentFilter.keywords.indexOf(word)
        this.deleteWord(word, index)
      } else {
        this.addNewWord(true, word)
      }
    },
    clearAll: function () {
      this.$emit('updateToucan', {
        type: 'clearAll'
      })
    },
    updateFilterLogic: function (logic) {
      this.$emit('updateToucan', {
        type: 'updateLogic',
        data: logic
      })
    },
    saveFilter: function () {
      if (this.currentFilter.keywords.length > 0) {
        this.$emit('updateToucan', {
          type: 'saveFilter'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.saved-filters {
  .saved-header {
    font-weight: 500;
    margin: $spacing-md 0 $spacing-xs 0;
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter,
.slide-down-leave-to
/* .slide-down-leave-active below version 2.1.8 */ {
  transform: translateY(-10%);
  opacity: 0;
}

.flex-kk {
  display: flex;
  max-height: 75px;
  flex-flow: row wrap;
  align-content: flex-start;
  margin-bottom: 10px;
}

.flex-aa {
  width: 33%;
  align-self: flex-start;
}

input[type="checkbox"]::after {
  background-color: #7bbe72;
}

.top-term {
  cursor: pointer;
}

.top-term:hover {
  color: $bg-secondary;
  font-weight: bold;
}

.filter-bar {
  margin-top: $spacing-md;
  display: flex;
  justify-content: space-between;

  .label {
    color: #3e3e3c;
    font-weight: 500;
    margin-right: $spacing-xs;
  }
}

.filter-list {
  display: flex;
}

.toucan-filter-bar {
  display: flex;
  background-color: $grey-light;
}

.toucan-filter-bar > .filter-input {
  height: 4rem;
  padding-left: 7px;
  width: 100%;
  box-sizing: border-box;
}

.suggestions {
  font-size: 10px;
  color: $grey-medium-light;
}

.advanced-filtering-label {
  color: $grey-dark;
  font-weight: 500;
  font-size: 12px;
}

.advanced-filter-options {
  font-weight: 100;
  margin-left: 5px;
  display: inline;
}

input[type='radio']::after,
input[type='radio']:checked::after {
  width: 16px;
  height: 16px;
  border-radius: 16px;
  top: -2px;
  left: -1px;
  position: relative;
  background-color: $white;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 1px solid $grey-lighter;
}

input[type='radio']:checked::after {
  background-color: $grey-dark;
  border-color: $white;
}

#filter-footer {
  margin-top: 17px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

#toucan-dropdown-window {
  padding: 0 20px 15px 10px;
  border-bottom: 1px solid #ddd;
}

.filter-input > .selectize-input {
  border: 1px solid #d0d0d0;
  padding: 6px 4px;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.selected-words {
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 0 !important;
  overflow: hidden;
}

.selected-words > .all-tags {
  margin: 2px 2px 6px 2px;
}

.filtered-tag {
  background-color: #fff;
  padding: 1px 6px;
  border: 1px solid $grey-lighter;
  border-radius: $border-radius-rounded-corners;
  font-weight: bold;
  font-size: 12px;
  color: $grey-dark;
}

.more-options-button.active {
  background-color: $bg-secondary;
  color: #fff;
  font-weight: bolder;
}

.more-options-button {
  font-size: 14px;
  font-weight: bolder;
  color: $bg-secondary;
  cursor: pointer;
}

.filter-footer {
  display: flex;
  justify-content: space-between;
  text-align: right;
  margin-top: 30px;
  cursor: pointer;
}

#filter-input > .search-icon {
  cursor: pointer;
  margin-left: 5px;
  font-size: 19px;
}

.add-word-filter {
  font-size: 12px;
  background-color: white;
  display: inline-block;
  border: 1px solid $bg-secondary;
  color: $bg-secondary;
  padding: 2px 8px;
  margin-right: 4px;
  cursor: pointer;
}

.filter-response-count {
  padding-top: $spacing-xs;
}

.filter-save-cancel {
  display: flex;

  .btn {
    margin: 0 $spacing-sm;
  }
}

@media only screen and (min-width: 640px) and (max-width: 992px) {
  #toucan-dropdown-window {
    width: 450px;
    padding: 10px 20px 15px 20px;
    right: -40px;
    left: auto;
  }
}

@media only screen and (min-width: 460px) and (max-width: 640px) {
  #toucan-dropdown-window {
    width: 370px;
    padding: 10px 20px 15px 20px;
    right: -40px;
    left: auto;
  }
}

@media only screen and (min-width: 415px) and (max-width: 460px) {
  #toucan-dropdown-window {
    width: 300px;
    padding: 10px 20px 15px 20px;
    right: -40px;
    left: auto;
  }

  #filter-footer {
    margin-top: 17px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  #toucan-filter-title {
    display: none;
  }

  .flex-kk {
    height: 105px;
    display: flex;
    flex-flow: column wrap;
    align-content: flex-start;
  }

  .flex-aa {
    width: 50%;
    align-self: flex-start;
  }
}

@media only screen and (min-width: 0) and (max-width: 415px) {
  #toucan-dropdown-window {
    width: 250px;
    padding: 10px 20px 15px 20px;
    right: -40px;
    left: auto;
  }

  #filter-footer {
    margin-top: 17px;
    display: flex;
    flex-wrap: wrap;

    /* justify-content: space-between; */
    justify-content: center;
  }

  #toucan-filter-title {
    display: none;
  }

  .flex-kk {
    height: 105px;
    display: flex;
    flex-flow: column wrap;
    align-content: flex-start;
  }

  .flex-aa {
    width: 50%;
    align-self: flex-start;
  }
}
</style>
